module.exports = __webpack_public_path__ + "static/media/O2.b706e6a7.svg";